import { cn } from "@/lib/utils";
// نسخة مصغَّرة (75×112) لمقاس العرض الحقيقيّ — الأصل 228×341 كان أكبر ٣ مرّات من الحاجة (LCP)
import logoAsset from "@/assets/lecmo-wolf-line-nav.webp";

type BrandWordmarkProps = {
  className?: string;
  /** @deprecated — kept for API compatibility */
  titleClassName?: string;
  /** @deprecated — kept for API compatibility */
  subtitleClassName?: string;
  /** Optional override for the wolf mark source */
  src?: string;
  /** Accessible label for the logo */
  alt?: string;
};

/**
 * قفل الشعار الأفقيّ: الذئب واقف (عامودي) على اليسار وكلمة LECMO بجانبه.
 * الذئب صورة (تُعكس عبر [&_img]:invert فوق الهيرو) والكلمة نصّ بلون currentColor.
 */
export function BrandWordmark({
  className,
  src,
  alt = "LECMO",
}: BrandWordmarkProps) {
  return (
    <span
      dir="ltr"
      className={cn("inline-flex shrink-0 items-center gap-2 leading-none sm:gap-3", className)}
    >
      <img
        src={src ?? logoAsset}
        alt={alt}
        width={75}
        height={112}
        // نسبة ثابتة تحفظ مكان الصورة قبل التحميل (CLS = 0)
        style={{ aspectRatio: "75 / 112" }}
        className="h-full w-auto shrink-0 object-contain"
        draggable={false}
      />

      <span
        aria-hidden="true"
        className="whitespace-nowrap font-sans text-[0.62em] font-light uppercase tracking-[0.34em]"
      >
        Lecmo
      </span>
    </span>
  );
}
